import React, { useEffect, useState } from "react";
import useAuth from '../../../hooks/useAuth';
import GearSpinner from '../../../components/GearSpinner/GearSpinner';
import BonusService from '../../../services/BonusService';
import NotFound from '../../not-found';

const MonthlyGoalTab = ({ active }) => {
    const {user} = useAuth();
    const [showSpinner, setShowSpinner] = React.useState(true);
    const [notFound, setNotFound] = React.useState(false);
    const [data, setData] = React.useState({});

    const bonusService = new BonusService();

    useEffect(() => {
        getPageData();
    },[active]);

    const getPageData = () => {
        const permalink = 'monthly-sales-goal';
        bonusService.getStaticPage(permalink).then(response => {
            if (response.status === 200 && response.data?.result?.static_page?.length > 0) {
                setData(response.data.result.static_page[0].fields);
            } else {
                setNotFound(true);
            }
        })
        .catch(() => {
            setNotFound(true);
        }).finally(() => {
            setTimeout(() => {
                setShowSpinner(false);
            }, 1500); // Simulate loading time
        });
    }

    if (notFound) {
        return <NotFound />;
    }

    return (
        <div className={`container tab-pane fade ${active ? 'show active' : ''} py-3 px-0`} id="monthly-sales-goal" role="tabpanel">
            <div className="row">
                <div className="col-md-12">
                    {showSpinner && <GearSpinner />}
                    {data?.content && !showSpinner && (
                        data.content.includes('<iframe') ? (
                            <div className="static-html-content" dangerouslySetInnerHTML={{ __html: data.content }} />
                        ) : (
                            <div className="static-html-content" dangerouslySetInnerHTML={{ __html: data.content }} />
                        )
                    )}
                </div>	
            </div>
        </div>
    )
}

export default MonthlyGoalTab;